import React, { useState, useEffect, useContext, useMemo } from 'react';
import ReportOptionCheckbox from './ReportOptionCheckbox';
import { AppContext } from '../../util/AppContext';
import { getConfigValue, getConfigCollection } from '../../util/getConfigValue';
import PropType from 'prop-types';
import Button from 'react-bootstrap/Button';
import Mustache from "mustache";


ReportingProductsOptionDropdown.propTypes = {
    isMenuVisible: PropType.bool,
    setIsMenuVisible: PropType.func,
    isEnabled: PropType.bool,  
    menuContentRef: PropType.object,
    menuRef: PropType.object,
    setFilterState: PropType.func,
    triggerToastAlert: PropType.func,
}

function ReportingProductsOptionDropdown(props) {
    const {
        isMenuVisible,
        setIsMenuVisible,  
        isEnabled,     
        menuContentRef,
        menuRef,
        setFilterState,        
        triggerToastAlert
    } = props;

    const [appState] = useContext(AppContext);
    
    const [table, setTable] = useState([]);
    const [allChecked, setAllChecked] = useState(true);
    const [selections, setSelections] = useState(appState?.sellSheetProductDetails.map(product => product.clientProductId));
    const minSelections = getConfigValue(appState.config.UtilizationDashboard?.ProductFilter?.MinSelectableProducts, appState)?.Value || 1;
    const maxSelections = getConfigValue(appState.config.UtilizationDashboard?.ProductFilter?.MaxSelectableProducts, appState)?.Value || 6;
    const utilizationDashboardConfig = useMemo(() => getConfigCollection(appState.config?.UtilizationDashboard, appState, 'UtilizationDashboard'), [appState]);
    const [previousSelections, setPreviousSelections] = useState({allChecked: allChecked, selections: selections});

    useEffect(() => {
        if (appState?.config) {
            setTable(buildProductTable([...(appState?.sellSheetProductDetails || [])], 5));
            setAllChecked(true);
            setFilterState(prevState => ({
                ...prevState, 
                allProducts: allChecked,
                selectedProductIds: selections
            }));
        }
    }, [appState]);

    function buildProductTable(products, itemCountPerColumn) {
        let result = Array.from({ length: itemCountPerColumn }, () => []);
        
        products.forEach((product, index) => {
            result[index % itemCountPerColumn].push(product);
        });

        return result;
    }
  
    function handleCheckAllCheckboxChange() {
        setSelections(allChecked ? [] : appState?.sellSheetProductDetails.map(product => product.clientProductId) );
        setAllChecked(!allChecked);
    }

    function handleCheckboxChange(product) {
        
        if (!selections.includes(product.clientProductId) && (selections?.length + 1) > maxSelections) {
            showMaxSelectionsMessage();
            return;
        }

        setSelections(prevSelections =>
            prevSelections.includes(product.clientProductId)
            ? prevSelections.filter(id => id !== product.clientProductId)
            : [...prevSelections, product.clientProductId]
        );
    }
 
    function showMaxSelectionsMessage() {
		const errorMessage = getConfigValue(appState.config?.UtilizationDashboard?.ProductFilter?.MinMaxSelectableProductsMessage, appState)?.Value;
		triggerToastAlert(
		    getConfigValue(appState.config?.UtilizationDashboard?.ProductFilter?.UserMessages?.MaxSelectableProducts?.Title, appState)?.Value,
		    Mustache.render(errorMessage, utilizationDashboardConfig),
		    false
		);
	}
    function showMinSelectionsMessage() {
		const errorMessage = getConfigValue(appState.config?.UtilizationDashboard?.ProductFilter?.MinMaxSelectableProductsMessage, appState)?.Value;
		triggerToastAlert(
		    getConfigValue(appState.config?.UtilizationDashboard?.ProductFilter?.UserMessages?.MinSelectableProducts?.Title, appState)?.Value,
		    Mustache.render(errorMessage, utilizationDashboardConfig),
		    false
		);
	}
    function handleApplyButtonClick(event) {
        if ((selections?.length) < minSelections) {
            showMinSelectionsMessage();
            return;
        }

        setFilterState(prevState => ({
            ...prevState, 
            allProducts: allChecked,
            selectedProductIds: selections
        }));
   
        setPreviousSelections({allChecked: allChecked, selections: selections});
        setIsMenuVisible(false);
    }
    function handleResetButtonClick(event) {
        resetFilter();
       
    }
    function handleCancelButtonClick(event) {
        resetFilter();
        if (previousSelections !== null) {
            setAllChecked(previousSelections.allChecked);
            setSelections(previousSelections.selections)
        }
        setIsMenuVisible(false);
    }
    function resetFilter() {
        setSelections([]);
        setAllChecked(false);
    }

    return (
        <div className="mb-4 my-lg-0">
            <button
                disabled={!isEnabled}
                ref={menuRef}
                onClick={() => setIsMenuVisible(isMenuVisible => !isMenuVisible)}
                aria-expanded={isMenuVisible ? "true" : "false"}
                className="border-0 px-0 bg-transparent text-start d-block"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside">
                <div
                    className={!isEnabled ? "p-3 opacity-50" : "p-3"}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <span className="type-20 type-bold me-2">{getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Product?.Label, appState)?.Value || null} ({allChecked ? Mustache.render(getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Product?.Aggregate.Label, appState)?.Value || null, {count:selections?.length } ): selections?.length})</span>
                        </div>
                        <span className="fa-solid fa-chevron-down"></span>
                    </div>
                </div>
            </button>
            <div
                ref={menuContentRef}
                className="dropdown-rc-options"
                id="dropdown-rc-options">
                <ul className={`dropdown-menu dropdown-menu-end ${isMenuVisible ? "show" : " "}`}>
                    <li className="ps-3 pe-3 mb-3 mt-3">   
                        <div className="type-16 mt-5 mb-3">{Mustache.render(getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Product?.AllProducts?.Heading, appState)?.Value || null, { count: appState?.sellSheetProductDetails?.length })}</div>                     
                        <div className='d-flex justify-content-center'>
                            <ReportOptionCheckbox
                                disabled={(!allChecked && selections?.length > 0)}
                                checked={allChecked}
                                key="allProducts"
                                label={Mustache.render(getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Product?.AllProducts?.Label, appState)?.Value, { count: appState?.sellSheetProductDetails?.length } )}
                                value="All Prodcuts"
                                onChange={(() => {
                                    handleCheckAllCheckboxChange()
                                })}
                                />
                            <Button size="lg" className='btn btn-link text-decoration-underline ms-auto px-4 py-2 no-hover' variant="secondary" onClick={handleResetButtonClick}>
                                {getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Product?.Reset, appState)?.Value || null}
                            </Button>
                        </div>
                        <hr></hr>
                        <h4 className="type-16 mt-5 mb-3">
                            {Mustache.render(getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Product?.SelectProducts?.Heading, appState)?.Value, utilizationDashboardConfig)}
                        </h4>  
                        <div className='container'>                     
                            {table?.map((row, rowIndex) => {
                                return (
                                    <div key={rowIndex} className='row row-cols-2 row-cols-md-3 row-cols-lg-4'>
                                        {row.map((product, index) => {
                                            return (  
                                                <div key={(rowIndex+1)*index} className="col text-nowrap">
                                                    <ReportOptionCheckbox
                                                        disabled={allChecked}
                                                        checked={!allChecked && (selections?.length > 0 && selections.includes(product.clientProductId))}
                                                        key={(rowIndex+1)*index}
                                                        label={product.name}
                                                        value={`${product.clientProductId}`}
                                                        onChange={(() => {
                                                            handleCheckboxChange(product)
                                                        })}
                                                    />
                                                </div>)
                                        })}
                                    </div>
                                )
                            })}
                            <div className='d-flex justify-content-center'>
                                <Button size="lg" className='btn btn-secondary px-4 py-2' variant="secondary" onClick={handleCancelButtonClick}>
                                    {getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Product?.Cancel, appState)?.Value || null}
                                </Button>
                                <Button size="lg" className='px-4 py-2 ms-md-3' variant='primary' onClick={handleApplyButtonClick}>
                                    {getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Product?.Apply, appState)?.Value || null}
                                </Button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default ReportingProductsOptionDropdown;